import { useEffect, useRef } from 'react';
import { useCreditTrack } from '../../../hooks/useCreditTrack';
import { SHOffer } from '../../../services/sortingHat';
import { UserType } from '../../../types';
import { useLocation } from 'react-router-dom';

type UseOfferCardProps = {
  offer: SHOffer;
  index: number;
  location: string;
  user: UserType;
  onViewOffer?: (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => void;
};

export function useOfferCard({ offer, index, location, user, onViewOffer }: UseOfferCardProps) {
  const cardRef = useRef<HTMLDivElement>(null);
  const { productViewedEvent } = useCreditTrack();
  const {pathname} = useLocation()


  useEffect(() => {
    const observer = new IntersectionObserver(
      async (entries, observer) => {
        if (entries[0].isIntersecting) {
          productViewedEvent({ offer, index, location, document: user?.cpf });
          onViewOffer && onViewOffer(entries, observer);
          observer.unobserve(entries[0].target);
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (cardRef.current) observer.observe(cardRef.current);
    return () => {
      if (cardRef.current) observer.unobserve(cardRef.current);
    };
  }, [offer, cardRef, pathname]);

  return {
    cardRef,
  };
}
